export default {
  getAllProducts(state) {
    return state.products;
  },
  getProductById(state) {
    return (id) => state.products.find((p) => p.id === id) || null
  }
  
}
